import React from "react";
import { makeStyles, Button } from "@material-ui/core";
import PropTypes from "prop-types";

import { ADD_NEW_CRITERIA, BACK, SELECT_BY } from "../../constants/strings";
import palette from "../styles/palette";
import { PlusIcon } from "../icons";
import CustomButton from "./CustomButton";
import SelectedCriteria from "./SelectedCriteria/SelectedCriteria";
import { Text, View } from "../Base";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    display: "flex",
    alignItems: "center",
    padding: `${typography.pxToRem(15)} ${typography.pxToRem(20)}`,
  },
  title: {
    color: "white",
    fontWeight: 500,
    fontSize: typography.pxToRem(18),
  },
  addButton: {
    textTransform: "none",
    background: "transparent",
    color: palette.sunburst,
    fontWeight: 500,
    fontSize: typography.pxToRem(16),
    marginLeft: typography.pxToRem(20),

    "&:hover": {
      background: "transparent",
    },
  },
}));

const HeaderOptions = React.memo(
  ({ onClickAdd, onClickBack, selectedCriteria, onRemoveCriteria }) => {
    const classes = useStyles();

    return (
      <View className={classes.container}>
        <Text className={classes.title}>{SELECT_BY}</Text>
        <Button
          variant="text"
          disableRipple
          disableFocusRipple
          onClick={onClickAdd}
          className={classes.addButton}
          endIcon={<PlusIcon />}
        >
          {ADD_NEW_CRITERIA}
        </Button>
        {!!selectedCriteria.length && (
          <SelectedCriteria
            selectedCriteria={selectedCriteria}
            onRemoveCriteria={onRemoveCriteria}
            onMoreClick={onClickAdd}
          />
        )}
        <CustomButton title={BACK} rightButton onClick={onClickBack} />
      </View>
    );
  }
);

HeaderOptions.propTypes = {
  onClickAdd: PropTypes.func.isRequired,
  onClickBack: PropTypes.func.isRequired,
};

export default HeaderOptions;
